

















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { ColorPreviewType } from '../Survey/Utilities/ColorUtility'
import { DefaultBranding } from '../Survey/Utilities/StaticColors'
import ChartPreview from './ChartPreview.vue'
import ColorInput from './ColorInput.vue'

@Component({
  components: {
    ChartPreview,
    ColorInput
  }
})
export default class ColorConfigSection extends Vue {
  @Prop() type!: ColorPreviewType
  @Prop({ required: true }) palette!: string[]
  @Prop({ required: false, default: () => false }) disabled!: boolean
  editablePalette: string[] = this.palette.slice() // This cannot be assigned via watch:immediate because initializing it without a value causes reactivity issues
  barCount = this.paletteData.barCount
  groupCount = this.paletteData.groupCount

  @Watch('palette')
  copyPalette () {
    // Create a local palette that can be edited without resetting color input container
    this.editablePalette = this.palette.slice()
  }

  updateColor (color: string, index: number) {
    const newPalette = [...this.editablePalette]
    newPalette[index] = color
    this.editablePalette = newPalette
  }

  confirm () {
    this.$emit('change', this.editablePalette)
  }

  get paletteData () {
    switch (this.type) {
      case ColorPreviewType.Monochromatic:
        return {
          questionTypes: ['Single-Select', 'Multi-Select'],
          defaultColors: [DefaultBranding().monochromatic],
          barCount: 5,
          groupCount: 1
        }
      case ColorPreviewType.Divergent:
        return {
          questionTypes: ['Rate', 'Matrix', 'Sentiment Analysis', 'Rank Distribution'],
          defaultColors: DefaultBranding().divergentPalette,
          barCount: 5,
          groupCount: 1,
          barName: 'Rate length',
          minBars: 3,
          maxBars: 10
        }
      case ColorPreviewType.Sequential:
        return {
          questionTypes: ['Average Rank', 'Number'],
          defaultColors: [DefaultBranding().sequentialPalette],
          barCount: 5,
          groupCount: 1
        }
      case ColorPreviewType.Qualitative:
        return {
          questionTypes: [
            'Single-Select with data cut',
            'Multi-Select with data cut',
            'Single-Select with variant',
            'Multi-Select with variant'
          ],
          defaultColors: DefaultBranding().qualitativePalette,
          barCount: 10,
          groupCount: 2,
          barName: 'Categories',
          minBars: 2,
          maxBars: 10
        }
      default:
        console.error('Invalid preview type:', this.type)
        return {
          questionTypes: [],
          defaultColors: [DefaultBranding().monochromatic],
          barCount: 5,
          groupCount: 1
        }
    }
  }

  get isDefaultColors () {
    return this.editablePalette.every((color, index) => {
      return this.paletteData.defaultColors[index] === color
    })
  }

  restoreDefaultColor () {
    setTimeout(() => { // reset after color picker has closed via click outside
      this.editablePalette = this.paletteData.defaultColors
      this.confirm()
    }, 10)
  }
}
